import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = ({ isActive }: IGenericObject) => {
  return StyleSheet.create({
    chatContainer: {
      height: '100%',
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 9999,
      background: '#FFF',
      transition: 'opacity 300ms ease-in-out, transform 300ms ease-in-out, scale 300ms ease-in-out',
      boxShadow: '0 2px 12px 0 rgb(0 0 0 / 30%), inset 0 1px 0 0 hsl(0deg 0% 100% / 18%)',
      borderRadius: 5,
      overflow: 'hidden',

      [media.tablet]: {
        left: 'auto',
        top: 'initial',
        height: 600,
        right: 20,
        bottom: 20,
      },

      [media.smallerThanTablet]: {
        top: 0,
        height: ['100vh', '100%'],
        width: '100vw',
      },
    },

    chatChannelWrapper: {
      display: 'flex',
    },
    header: {
      background: palette.red,
      color: '#FFF',
      fontSize: 20,
      fontWeight: 'bold',
      padding: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    closeButton: {
      background: 'transparent',
      border: 'none',

      [children('.close-icon svg')]: {
        width: 20,
        height: 20,
      },

      [children('.close-icon g')]: {
        stroke: '#FFF',
      },
    },

    loadingSpinner: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 100,
    },

    chatContentContainer: {
      position: 'relative',
    },

    showChat: {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },

    hideChat: {
      opacity: 0,
      transform: 'translateY(100%) scale(0)',
    },
  });
};
